import script from "./RewardRisk.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardRisk.vue?vue&type=script&setup=true&lang=js"

import "./RewardRisk.vue?vue&type=style&index=0&id=9249fae6&lang=scss"

const __exports__ = script;

export default __exports__